import { Button, Card, Collapse, Divider } from '@blueprintjs/core';
import { Users } from '@just-in-types';
import * as React from 'react';
import ActiveCheckIn, { ActiveCheckInProps } from '.';
import Coupon from './Coupon';
import { CouponGroups } from './Coupons';

// Excessive prop drilling? Maybe the active check-in should be in Redux
interface Props {
  activeBusinessId: ActiveCheckInProps['businessId'];
  activeSiteId: ActiveCheckInProps['siteId'];
  coupons: Users.Coupon[];
  redeeming: boolean;
  redeemCoupon: ActiveCheckIn['redeemCoupon'];
  title: string;
}

interface State {
  isOpen: boolean;
}

export default class CouponsList extends React.PureComponent<Props, State> {
  public constructor(props: Props) {
    super(props);

    this.state = { isOpen: props.title === CouponGroups.ACTIVE };
  }

  public render() {
    const {
      activeBusinessId,
      activeSiteId,
      coupons,
      redeeming,
      redeemCoupon,
      title,
    } = this.props;
    const { isOpen } = this.state;
    const titleIntent =
      title === CouponGroups.ACTIVE
        ? 'success'
        : title === CouponGroups.EXPIRED
          ? 'danger'
          : 'primary';

    return (
      <Card style={{ marginBottom: 10, padding: 0 }}>
        <Button
          fill={true}
          large={true}
          minimal={true}
          intent={titleIntent}
          onClick={this.toggleOpen}
          rightIcon={isOpen ? 'chevron-up' : 'chevron-down'}>
          {title}
        </Button>
        <Collapse isOpen={isOpen}>
          <Divider />
          <div style={{ padding: 20 }}>
            {coupons.map((coupon, index) => (
              <Coupon
                activeBusinessId={activeBusinessId}
                activeSiteId={activeSiteId}
                coupon={coupon}
                listTitle={title}
                key={index}
                redeemCoupon={redeemCoupon}
                redeeming={redeeming}
              />
            ))}
          </div>
        </Collapse>
      </Card>
    );
  }

  private toggleOpen = () =>
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));
}



// WEBPACK FOOTER //
// ./src/views/CheckIns/ActiveCheckIn/CouponsList.tsx